<div class="settings-map-wrapper">
  <div class="content-center">
    <div *ngIf="isLoading" class="loading-state">
      <div class="spinner"></div>
      <p>Loading lists...</p>
    </div>

    <div *ngIf="!isLoading">
      <div class="lists-header" [class.blur-background]="showModal">
        <a class="add-custom-list" (click)="openAddList($event)"
          >Add Custom List</a
        >
      </div>

      <div class="table-card">
        <div class="table-head" [class.blur-background]="showModal">
          <div class="th th-name">Name</div>
          <div class="th th-actions">Actions</div>
        </div>

        <div class="card-stack">
          <div class="table-body" [class.blur-background]="showModal">
            <div *ngIf="errorMessage" class="state-msg error">
              {{ errorMessage }}
            </div>

            <div
              *ngIf="!errorMessage && customLists.length === 0"
              class="state-msg"
            >
              No custom lists found.
            </div>

            <div class="table-row" *ngFor="let list of customLists">
              <div class="td td-name">{{ list.name }}</div>
              <div class="td td-actions">
                <a class="edit-link" (click)="openEditList(list)">Edit</a>
              </div>
            </div>
          </div>

          <div class="inline-overlay-panel" *ngIf="showModal">
            <div
              class="dropdown-backdrop"
              *ngIf="isTemplateDropdownOpen"
              (click)="isTemplateDropdownOpen = false"
            ></div>

            <div class="overlay-header">
              <h3 class="overlay-title">
                {{
                  modalMode === 'new' ? 'New Custom List' : 'Edit Custom List'
                }}
              </h3>
              <button class="close-icon-btn" (click)="closeModal()">✕</button>
            </div>

            <div class="overlay-body">
              <div class="form-row-header">
                <div class="col-left">
                  <label class="label-text">Custom List</label>
                </div>
                <div class="col-right">
                  <label class="toggle-item">
                    <input
                      type="checkbox"
                      class="native-toggle"
                      [ngModel]="isRoleMembersList"
                      (click)="onRoleTypeClick($event)"
                    />
                    <wm-common-text
                      class="toggle-label"
                      [data]="{ text: 'Role Members List' }"
                    ></wm-common-text>
                  </label>
                </div>
              </div>

              <input
                #fileInput
                type="file"
                accept="image/*"
                (change)="onImageSelected($event)"
                hidden
              />

              <div
                class="input-wrapper"
                [class.force-invalid]="showValidation && !currentList.name"
              >
                <wm-common-textfield
                  [(ngModel)]="currentList.name"
                  [data]="{
                    label: 'Name',
                    placeholder: 'Name',
                    type: 'text',
                    variant: 'outline',
                    required: true
                  }"
                ></wm-common-textfield>
                <div
                  *ngIf="showValidation && !currentList.name"
                  class="validation-error"
                >
                  Name is required.
                </div>
              </div>

              <div class="input-wrapper" *ngIf="isRoleMembersList">
                <label class="label-text input-label">Select Role</label>
                <div class="select-wrapper">
                  <wm-common-dropdown
                    [(ngModel)]="currentList.roleId"
                    (change)="loadRoleMembers()"
                    [data]="roleDropdownData"
                  ></wm-common-dropdown>
                </div>
              </div>

              <ng-container *ngIf="!isRoleMembersList">
                <div class="template-wrapper">
                  <div class="custom-template-dropdown">
                    <button
                      type="button"
                      class="template-header-btn"
                      (click)="toggleTemplateDropdown()"
                    >
                      LOAD ITEMS FROM TEMPLATE
                      <mat-icon class="arrow-icon">{{
                        isTemplateDropdownOpen
                          ? 'keyboard_arrow_up'
                          : 'keyboard_arrow_down'
                      }}</mat-icon>
                    </button>

                    <div
                      class="template-list-container"
                      *ngIf="isTemplateDropdownOpen"
                    >
                      <div
                        class="template-option"
                        *ngFor="let t of globalCustomLists"
                        (click)="selectTemplateFromDropdown(t)"
                      >
                        {{ t.name }}
                      </div>
                      <div
                        class="template-option placeholder"
                        *ngIf="globalCustomLists.length === 0"
                      >
                        No templates available.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="list-items-section">
                  <label class="label-text">List Items</label>

                  <div class="list-controls">
                    <button class="btn blue-btn small" (click)="addNewItem()">
                      NEW ITEM
                    </button>
                    <button
                      class="btn grey-btn small"
                      (click)="toggleBulkAdd()"
                    >
                      BULK ADD
                    </button>
                  </div>

                  <div class="new-item-form-card" *ngIf="isAddingItem">
                    <div class="sub-form-header">
                      <h4 class="sub-form-title">
                        {{
                          editingItemIndex !== null
                            ? 'Edit List Item'
                            : 'New List Item'
                        }}
                      </h4>
                      <button class="close-sub-btn" (click)="cancelItemForm()">
                        ✕
                      </button>
                    </div>

                    <div class="sub-form-inputs">
                      <input
                        type="text"
                        class="std-input"
                        placeholder="Value *"
                        [(ngModel)]="newItemData.value"
                      />
                      <input
                        type="text"
                        class="std-input"
                        placeholder="Label (Text)"
                        [(ngModel)]="newItemData.label"
                      />
                    </div>

                    <div class="sub-form-image">
                      <div class="image-controls">
                        <button
                          class="btn blue-btn small add-img-btn"
                          (click)="triggerFileSelect()"
                        >
                          {{
                            newItemData.imagePath ? 'CHANGE IMAGE' : 'ADD IMAGE'
                          }}
                        </button>
                        <p class="file-hint">
                          Valid file types: png, jpg, jpeg
                        </p>
                      </div>

                      <span
                        *ngIf="newItemData.imagePath"
                        class="image-preview-wrapper"
                      >
                        <a
                          href="javascript:void(0)"
                          class="image-path-link"
                          (click)="openImage(newItemData.imagePath)"
                        >
                          {{ newItemData.fileName || 'View Image' }}
                        </a>
                        <button
                          class="icon-btn"
                          (click)="removeNewItemImage()"
                          title="Remove image"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      </span>
                    </div>

                    <div class="sub-form-actions">
                      <button
                        class="btn blue-btn small"
                        (click)="confirmAddItem()"
                      >
                        {{
                          editingItemIndex !== null ? 'UPDATE ITEM' : 'ADD ITEM'
                        }}
                      </button>
                    </div>
                  </div>

                  <div class="new-item-form-card" *ngIf="isBulkAdding">
                    <div class="sub-form-header">
                      <h4 class="sub-form-title">Bulk Add Items</h4>
                      <button class="close-sub-btn" (click)="toggleBulkAdd()">
                        ✕
                      </button>
                    </div>

                    <div class="sub-form-inputs full-width">
                      <label class="file-hint"
                        >Enter items separated by commas (e.g. Item 1, Item 2,
                        Item 3)</label
                      >
                      <textarea
                        class="std-input std-textarea"
                        rows="4"
                        [(ngModel)]="bulkAddText"
                      ></textarea>
                    </div>

                    <div class="sub-form-actions">
                      <button
                        class="btn blue-btn small"
                        (click)="confirmBulkAdd()"
                      >
                        ADD ITEMS
                      </button>
                    </div>
                  </div>

                  <p class="drag-hint" *ngIf="!isAddingItem && !isBulkAdding">
                    Click and drag to reorder
                  </p>

                  <div class="items-container">
                    <div
                      class="list-item-row"
                      *ngFor="let it of currentList.items; let i = index"
                      draggable="true"
                      (dragstart)="onDragStart($event, i)"
                      (dragover)="onDragOver($event)"
                      (drop)="onDrop($event, i)"
                    >
                      <div class="item-name">
                        <a
                          *ngIf="it.imagePath"
                          href="javascript:void(0)"
                          class="image-path-link item-link"
                          (click)="openImage(it.imagePath)"
                          >[Image]</a
                        >
                        {{ it.text || it.value }}
                      </div>

                      <div class="item-actions">
                        <button
                          class="icon-btn"
                          (click)="editItem(it, i)"
                          title="Edit"
                        >
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button
                          class="icon-btn"
                          (click)="
                            requestDeleteItem(it.id, it.text || it.value)
                          "
                          title="Delete"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>

                    <div
                      *ngIf="currentList.items.length === 0"
                      class="state-msg"
                    >
                      No items added yet.
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="isRoleMembersList">
                <div class="list-items-section">
                  <label class="label-text">List Items</label>
                  <p class="drag-hint">
                    Associate images with the Role Members listed below by
                    clicking the edit icon.
                  </p>

                  <div
                    class="new-item-form-card"
                    *ngIf="isAddingItem && editingItemIndex !== null"
                  >
                    <div class="sub-form-header">
                      <h4 class="sub-form-title">Edit List Item</h4>
                      <button class="close-sub-btn" (click)="cancelItemForm()">
                        ✕
                      </button>
                    </div>

                    <div class="sub-form-inputs">
                      <input
                        type="text"
                        class="std-input disabled-input"
                        [(ngModel)]="newItemData.value"
                        disabled
                      />
                      <input
                        type="text"
                        class="std-input disabled-input"
                        [(ngModel)]="newItemData.label"
                        disabled
                      />
                    </div>

                    <div class="sub-form-image">
                      <div class="image-controls">
                        <button
                          class="btn blue-btn small add-img-btn"
                          (click)="triggerFileSelect()"
                        >
                          {{
                            newItemData.imagePath ? 'CHANGE IMAGE' : 'ADD IMAGE'
                          }}
                        </button>
                        <p class="file-hint">
                          Valid file types: png, jpg, jpeg
                        </p>
                      </div>

                      <span
                        *ngIf="newItemData.imagePath"
                        class="image-preview-wrapper"
                      >
                        <a
                          href="javascript:void(0)"
                          class="image-path-link"
                          (click)="openImage(newItemData.imagePath)"
                        >
                          {{ newItemData.fileName || 'View Image' }}
                        </a>
                        <button
                          class="icon-btn"
                          (click)="removeNewItemImage()"
                          title="Remove image"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      </span>
                    </div>

                    <div class="sub-form-actions">
                      <button
                        class="btn blue-btn small"
                        (click)="confirmAddItem()"
                      >
                        UPDATE ITEM
                      </button>
                    </div>
                  </div>

                  <div class="items-container">
                    <div
                      class="list-item-row"
                      *ngFor="let it of currentList.items; let i = index"
                    >
                      <div class="item-name">
                        <a
                          *ngIf="it.imagePath"
                          href="javascript:void(0)"
                          class="image-path-link item-link"
                          (click)="openImage(it.imagePath)"
                          >[Image]</a
                        >
                        {{ it.text }}
                        <span *ngIf="it.value && it.value !== it.text"
                          >({{ it.value }})</span
                        >
                      </div>
                      <div class="item-actions">
                        <button
                          class="icon-btn"
                          (click)="editItem(it, i)"
                          title="Edit"
                        >
                          <mat-icon>edit</mat-icon>
                        </button>
                      </div>
                    </div>
                    <div
                      *ngIf="currentList.items.length === 0"
                      class="state-msg"
                    >
                      Select a role above to populate this list.
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>

            <div class="overlay-footer">
              <button class="btn footer-cancel" (click)="closeModal()">
                CANCEL
              </button>

              <button
                class="btn footer-remove"
                *ngIf="modalMode === 'edit'"
                type="button"
                (click)="requestRemoveCustomList()"
              >
                REMOVE CUSTOM LIST
              </button>

              <button class="btn footer-save" (click)="saveList()">SAVE</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <wm-common-confirmation-modal
    [data]="confirmData"
    (onYesClick)="onConfirmYes()"
    (onNoClick)="onConfirmNo()"
    [isApplicantMobileview]="true"
  >
  </wm-common-confirmation-modal>
</div>
